
export default function contentService($http) {

    // method expects a parameters object:
    // p.contentTypes = ['course','majorminoritem'];
    // p.count = '2000';
    // p.query = {
    //     isArchived: false
    // };
    // p.fields = ['type', 'keywords'];

    function get(q) {
        return $http.get('/webapi/contentservice/Get?parameters=' + JSON.stringify(q)).then(function (result) {
            return result.data.response;
        });
    };

    // this endpoint is cached for 10 hours
    function getcached(q) {
        return $http.get('/webapi/contentservice/Get?parameters=' + JSON.stringify(q), {
            headers: { 'Cache-Control': 'max-age=36000' }
        }).then(function (result) {
            return result.data.response;
        });
    }

    return {
        get: get,
        getcached: getcached
    };
};

